import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import KnowledgeDetail from "../pages/knowledge-detail/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/knowledge/:categoryId",
    element: <KnowledgeDetail />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;